import React from "react";
import { Link } from "react-router-dom";
import { localizedPath, useLang } from "@/lib/i18n";
import useSEO from "@/lib/useSEO";

// Nginx answers unknown URLs with a real 404; this is what people see there.
export default function NotFound() {
  const { lang } = useLang();
  const id = lang === "id";
  useSEO({
    title: id ? "Halaman tidak ditemukan — Mindovia" : "Page not found — Mindovia",
    description: id ? "Halaman yang kamu cari tidak ada." : "The page you're looking for doesn't exist.",
    robots: "noindex, follow, noarchive",
  });
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="not-found-page">
      <h1 className="font-display text-3xl">{id ? "Halaman tidak ditemukan" : "Page not found"}</h1>
      <p className="mt-3 text-muted-foreground">
        {id ? "Halaman yang kamu cari tidak ada." : "The page you're looking for doesn't exist."}
      </p>
      <Link to={localizedPath("/instruments", lang)} className="inline-block mt-4 text-terracotta-600 hover:underline">
        {id ? "Jelajahi instrumen" : "Browse instruments"}
      </Link>
    </div>
  );
}
